'use strict';

var React = require('react');
var classnames = require('classnames');
var label = require('./input_commons').label;
var helpBlock = require('./input_commons').helpBlock;

class Input extends React.Component {

  constructor (props) {
    super(props);
    this.displayName = 'Input';
  }

  render () {
    return (
      <div className={classnames(['control-group', this.props.className])} style={this.props.style}>
        {label.call(this)}
        <div className="controls" style={this.props.controlsStyle}>
          <input className={this.props.inputClass}
                 id={this.props.id}
                 type={this.props.type || 'text'}
                 value={this.props.value}
                 defaultValue={this.props.defaultValue}
                 onChange={this.props.onChange}
                 name={this.props.name}
                 placeholder={this.props.placeholder}/>
          {helpBlock.call(this)}
        </div>
      </div>
    );
  }

}

module.exports = Input;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/input.jsx